// css =>
import "../../BaseStructure.css";
import Styled from "./service-box.module.css";

// react =>
import { useEffect, useState } from "react";

// context =>
import { useTheme } from '../../context/theme-context';

const ServiceBox = (props) => {
    const { theme, toggleTheme } = useTheme();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1200);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1200);
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div 
            className={`col-6 ${ Styled.ServiceBox } `}
            style={{
                marginRight: props.index % 2 === 0 ? "20px" : "10px",
            }}
        >
            <div className="row">
                <div
                    className={ Styled.ServiceShape }
                    style={{
                        backgroundColor: theme === "day" ? "#E6E6E6" : "",
                        borderColor: theme === "day" ? "#464B3C" : ""
                    }}
                ></div>

                <div
                    className={ Styled.ServiceIconBox }
                    style={{
                        backgroundColor: theme === "day" ? "#C9CCC2" : "",
                        borderColor: theme === "day" ? "#474C3D" : ""
                    }}>
                    <img 
                        loading="lazy"
                        src={ props.serviceIcon }
                        alt={ props.serviceTittle }

                        style={{ 
                            width: isMobile ? props.iconWidth : props.desktopIconWidth + "px",
                            height: isMobile ? props.iconHeight : props.desktopIconHeight + "px",
                        }}
                    />
                </div>

                <div
                    className={`col-12 ${ Styled.ServiceTittleBox } `}
                    style={{
                        backgroundColor: theme === "day" ? "#C9CCC2" : ""
                    }}
                >
                    <p
                        style={{
                            color: theme === "day" ? "#000000" : ""
                        }}
                    >{ props.serviceTittle }</p>
                </div>
            </div>
        </div>
    );
}

export default ServiceBox;
